import IconFlowIconButton from "../UI/IconFlowIconButton"
import IconFlowSelect from "../UI/IconFlowSelect"
import { STATES } from "lib/states"
import PreactTextField from "../UI/PreactTextField"
import useEvent from 'landing_pages/common/use-event'
import Inputmask from 'inputmask'
import { QuestionProps } from "landing_pages/types"

import CheckIcon from "../svgIcons/CheckIcon"
import CloseIcon from "../svgIcons/CloseIcon"
import TwoLineIcon from "../svgIcons/TwoLineIcon"
import ThreeLineIcon from "../svgIcons/ThreeLineIcon"
import FiveLineIcon from "../svgIcons/FiveLineIcon"
import HalfLineIcon from "../svgIcons/HalfLineIcon"
import OneLineIcon from "../svgIcons/OneLineIcon"
import FourLineIcon from "../svgIcons/FourLineIcon"
import CalendarIcon from "../svgIcons/CalendarIcon"
import PersonIcon from "../svgIcons/PersonIcon"
import PersonSprintingIcon from "../svgIcons/PersonSprintingIcon"
import PersonJoggingIcon from "../svgIcons/PersonJoggingIcon"
import PersonWalkingIcon from "../svgIcons/PersonWalkingIcon"
import PersonWavingIcon from "../svgIcons/PersonWavingIcon"
import FastClockIcon from "../svgIcons/FastClockIcon"
import ClockIcon from "../svgIcons/ClockIcon"
import CalendarBlankIcon from "../svgIcons/CalendarBlankIcon"
import CalendarPlusIcon from "../svgIcons/CalendarPlusIcon"

import LightningIcon from "../svgIcons/LightningIcon"
import WaterIcon from "../svgIcons/WaterIcon"
import FireIcon from "../svgIcons/FireIcon"
import LaptopIcon from "../svgIcons/LaptopIcon"
import BrainPowerIcon from "../svgIcons/BrainPowerIcon"
import JusticeIcon from "../svgIcons/JusticeIcon"
import QuillWritingIcon from "../svgIcons/QuillWritingIcon"
import SwissArmyIcon from "../svgIcons/SwissArmyIcon"
import ToolsIcon from "../svgIcons/ToolsIcon"
import { isIconButtonType } from "landing_pages/templates/icon-flow/Step"

const iconMap = {
  'Citizen': [CheckIcon, CloseIcon],
  'Education': [OneLineIcon, TwoLineIcon, ThreeLineIcon, FourLineIcon, FiveLineIcon, HalfLineIcon],
  'HighestEducation': [OneLineIcon, TwoLineIcon, ThreeLineIcon],
  'HighSchool': [CheckIcon, CheckIcon, CloseIcon],
  'Employed': [CheckIcon, CloseIcon],
  'Age': PersonIcon,
  'GraduationYear': CalendarIcon,
  'Military': [CheckIcon, CloseIcon],
  'Military2': [PersonSprintingIcon, PersonJoggingIcon, PersonWalkingIcon, PersonWavingIcon],
  'Enroll': [FastClockIcon, ClockIcon, CalendarBlankIcon, CalendarPlusIcon],
  'Application': [CheckIcon, CloseIcon],
  'Interest': [LaptopIcon, BrainPowerIcon, JusticeIcon, QuillWritingIcon, SwissArmyIcon, ToolsIcon],
  'Trade': [LightningIcon, WaterIcon, FireIcon]
}

const AGES = [...Array(44).keys()].map(i => String(i + 18)).concat( '62+')

Inputmask.extendDefinitions({
  '2': {
    validator: '[2-9]',
  }
})

export default function IconFlowQuestion({ question, value, setValue, isError, mapsAutoComplete, onChange}: QuestionProps) {
  const handleSelect = useEvent((value) => {
    setValue(value)
    onChange?.()
  })

  const type = question.type
  if(type === 'text' || type === 'email' || type === 'tel' || type === 'zip') {
    const inputMask = type === 'tel' ? '(299) 299-9999' : ''
    const inputType = type === 'zip' ? 'text' : type
    return <PreactTextField
      type={inputType}
      label={question.text}
      value={value}
      inputMask={inputMask}
      mapsAutoComplete={mapsAutoComplete}
      onInput={event => { setValue(event.currentTarget.value) }}
      onChange={onChange}
      isError={isError}
    />
  } else if(type === 'select' && isIconButtonType(question)) {
    const options = question.options
    return (
      <>
        {options && options.map((option, index) => {
          const Icon = iconMap[question.key]?.[index]
          return (
            <div key={`${question.key}_option_${index}`} className="icon-button">
              <IconFlowIconButton
                text={option}
                icon={Icon && <Icon/>}
                onClick={() => { setValue(option); onChange?.() }}
                isSelected={value === option}
              />
            </div>
          )
        })}
      </>
    )
  } else {
    const Icon = iconMap[question.key]
    const options = type === 'state' ? STATES.map(_ => _.abbreviation) : (type === 'age' ? AGES : type === 'select' ? question.options : [])
    return (
      <IconFlowSelect
        label={question.text}
        icon={Icon && <Icon/>}
        value={value}
        options={options}
        onChange={handleSelect}
        showLabel={!Icon}
        isError={isError}
        large={!!Icon}
      />
    )
  }
}
